(ns hai.home.desktop
  "Home — daily dashboard page. Renders the wide (desktop) body; the narrow body
   lives in [[hai.home.mobile]] and is selected by the dispatcher via the
   route's :mobile-view."
  (:require
   [hai.home.calendar :as calendar-state]
   [hai.home.desktop.mini-apps.calendar :as calendar]
   [hai.home.desktop.mini-apps.clock :as clock]
   [hai.home.desktop.mini-apps.notes :as notes]
   [hai.home.desktop.mini-apps.progress :as progress]
   [hai.home.desktop.mini-apps.tasks :as tasks]
   [hai.home.desktop.newtab-toggle :as newtab-toggle]
   [hai.home.desktop.views :as views]
   [hai.home.events]
   [hai.ui.components :as c]
   [hai.ui.rf-sugar :refer [<s]]))

(defn- desktop-body []
  (let [loading? @(<s [::calendar-state/loading?])
        error?   @(<s [::calendar-state/error?])]
    [views/page-desktop
     (cond
       loading?
       [c/Flex {:justify "center" :py "9"}
        [c/Spinner {:size "3"}]]

       error?
       [c/Flex {:justify "center" :py "9"}
        [c/Text {:color "red" :size "3"} "Failed to load calendar events. Please try again."]]

       :else
       [:<>
        [views/top-row
         ;; Toggle rides under the clock in the left (auto-width) column.
         [:div
          [clock/panel]
          [newtab-toggle/control]]
         [notes/panel]]
        [progress/panel]
        [views/two-columns
         [calendar/panel]
         [tasks/panel]]])]))

(defn page [_route]
  [desktop-body])
